<template>
    <v-dialog v-model="dialogShow" persistent>
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title
                    ><span class="text-h5" v-if="dialogType === 'account'"
                        >Lp Account Detail</span
                    >
                    <span class="text-h5" v-else
                        >Lp Position Detail</span
                    ></v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-row v-if="dialogType === 'account'" style="color: white">
                    <v-col cols="4" class="pb-0"> LP </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{ dialogItem.LP.toUpperCase() }}
                    </v-col>
                    <v-col cols="4" class="pb-0"> Margin% </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        <div
                            :style="
                                'color:' +
                                (dialogItem['Margin Utilization %'] > 50
                                    ? 'red'
                                    : 'white')
                            "
                        >
                            {{
                                dialogItem["Margin Utilization %"].toFixed(2) +
                                "%"
                            }}
                        </div>
                    </v-col>
                    <v-col cols="4" class="pb-0"> Used </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{
                            numberWithCommas(
                                parseFloat(dialogItem.Margin).toFixed(2)
                            )
                        }}
                    </v-col>
                    <v-col cols="4" class="pb-0"> Free </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{
                            numberWithCommas(
                                dialogItem["Free Margin"].toFixed(2)
                            )
                        }}
                    </v-col>
                    <v-col cols="4" class="pb-0"> Equity </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{ numberWithCommas(dialogItem.Equity.toFixed(2)) }}
                    </v-col>
                    <v-col cols="4" class="pb-0"> FPNL </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{
                            numberWithCommas(
                                dialogItem["Unrealized P&L"].toFixed(2)
                            )
                        }}
                    </v-col>
                    <v-col cols="4" class="pb-0"> Balance </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{ numberWithCommas(dialogItem.Balance.toFixed(2)) }}
                    </v-col>
                    <v-col cols="4" class="pb-0"> Credit </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{
                            dialogItem.Credit == null
                                ? null
                                : numberWithCommas(
                                      parseFloat(dialogItem.Credit).toFixed(2)
                                  )
                        }}
                    </v-col>
                    <v-col cols="4" class="pb-0"> Last Update </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{ dialogItem.updated_at }}
                    </v-col>
                </v-row>
                <v-row v-else style="color: white">
                    <v-col cols="4" class="pb-0"> LP </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{ dialogItem.LP.toUpperCase() }}
                    </v-col>
                    <v-col cols="4" class="pb-0"> Symbol </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{ dialogItem.Symbol }}
                    </v-col>
                    <v-col cols="4" class="pb-0"> Margin Rate </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{
                            dialogItem["Margin Rate"] === "N/A"
                                ? dialogItem["Margin Rate"]
                                : parseInt(dialogItem["Margin Rate"] * 100) +
                                  "%"
                        }} </v-col
                    ><v-col cols="4" class="pb-0"> Position </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{
                            dialogItem.Position === "N/A"
                                ? dialogItem.Position
                                : numberWithCommas(
                                      parseFloat(dialogItem.Position).toFixed(2)
                                  )
                        }} </v-col
                    ><v-col cols="4" class="pb-0"> Total VWAP </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{
                            dialogItem["Total VWAP"] === "N/A"
                                ? dialogItem["Total VWAP"]
                                : dialogItem["Total VWAP"].toFixed(
                                      dialogItem["digits"]
                                  )
                        }} </v-col
                    ><v-col cols="4" class="pb-0"> Margin </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{
                            dialogItem.Margin === "N/A"
                                ? dialogItem.Margin
                                : numberWithCommas(
                                      parseFloat(dialogItem.Margin).toFixed(2)
                                  )
                        }} </v-col
                    ><v-col cols="5" class="pb-0"> Unrealized P&L </v-col>
                    <v-col cols="7" class="pb-0" style="text-align: right">
                        {{
                            dialogItem[
                                "Margin Unrealized P&L in Account CCY"
                            ] === "N/A"
                                ? dialogItem[
                                      "Margin Unrealized P&L in Account CCY"
                                  ]
                                : numberWithCommas(
                                      parseFloat(
                                          dialogItem[
                                              "Margin Unrealized P&L in Account CCY"
                                          ]
                                      ).toFixed(2)
                                  )
                        }} </v-col
                    ><v-col cols="7" class="pb-0">
                        Unrealized P&L in Quote CCY
                    </v-col>
                    <v-col cols="5" class="pb-0" style="text-align: right">
                        {{
                            dialogItem["Unrealized P&L in Quote CCY"] === "N/A"
                                ? dialogItem["Unrealized P&L in Quote CCY"]
                                : numberWithCommas(
                                      parseFloat(
                                          dialogItem[
                                              "Unrealized P&L in Quote CCY"
                                          ]
                                      ).toFixed(2)
                                  )
                        }} </v-col
                    ><v-col cols="4" class="pb-0"> Last Update </v-col>
                    <v-col cols="8" class="pb-0" style="text-align: right">
                        {{ dialogItem.updated_at }}
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="$emit('close')">
                    Ok
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { helper } from "@components/mixins/helper";

export default {
    mixins: [snackbar, helper],
    props: {
        dialogShow: {
            type: Boolean,
            default: false,
        },
        close: {
            type: Function,
            default: () => {},
        },
        dialogType: {
            type: String,
            default: undefined,
        },
        dialogItem: {
            type: Object,
            default: () => ({
                LP: "",
                "Margin Utilization %": 0,
                Margin: 0,
                "Free Margin": 0,
                Equity: 0,
                "Unrealized P&L": 0,
                Balance: 0,
                Credit: 0,
                updated_at: "",
                Symbol: "",
                "Margin Rate": "N/A",
                Position: "N/A",
                "Total VWAP": "N/A",
                "Margin Unrealized P&L in Account CCY": "N/A",
                "Unrealized P&L in Quote CCY": "N/A",
                digits: 2,
            }),
        },
    },
    data() {
        return {};
    },

    watch: {
        dialogItem(nv) {
            console.log("nv", nv);
        },
    },
};
</script>
